module.exports = __webpack_public_path__ + "static/img/icon_radio.61b4e555.svg";